// Others
import { urlApiQuarantine } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IBodyUpdate, IQueryParamBase } from '~/utils/interface/common';
import { IBodyRepairedQuarantine, IDetailQuarantine, IQuarantine } from '~/utils/interface/quarantine';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';

const quarantineApi = {
  getListQuarantine: (params: IQueryParamBase) => {
    const url = urlApiQuarantine.getListQuarantine;
    return axiosClient.get<IBaseResponse<IListDataResponse<IQuarantine[]>>>(url, { params });
  },

  createRepairedQuarantine: (body: IBodyRepairedQuarantine) => {
    const { quarantineId, repairedQuantity } = body;
    const bodyData = {
      repairedQuantity: repairedQuantity,
    };
    const url = urlApiQuarantine.createRepairQuarantine(String(quarantineId));
    return axiosClient.put<IBaseResponse>(url, bodyData);
  },

  deleteQuarantine: (quarantineId: string) => {
    const url = urlApiQuarantine.deleteQuarantine(quarantineId);
    return axiosClient.delete<IBaseResponse>(url);
  },

  createQuarantine: (formData: FormData) => {
    const url = urlApiQuarantine.createQuarantine;
    return axiosClient.post<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  getDetailQuarantine: (quarantineId: string) => {
    const url = urlApiQuarantine.getDetailQuarantine(quarantineId);
    return axiosClient.get<IBaseResponse<IDetailQuarantine>>(url);
  },

  updateQuarantine: (params: IBodyUpdate<FormData>) => {
    const { id, body } = params;
    const url = urlApiQuarantine.updateQuarantine(id);
    return axiosClient.put<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },
};

export default quarantineApi;
